import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, Instagram, Linkedin, ArrowUpRight, MapPin, MessageCircle } from 'lucide-react';
import { company, navLinks, services } from '../mock/mock';

export default function Footer() {
  return (
    <footer className="relative mt-10 bg-[#0b132b] text-slate-300">
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-16 grid gap-12 md:grid-cols-4">
        <div className="md:col-span-1">
          <div className="flex items-center gap-2.5 mb-4">
            <span className="relative w-9 h-9 inline-block">
              <span className="absolute top-[3px] left-[7px] w-6 h-6 rounded-[7px] border-[3px] border-[#21A8CB]" />
              <span className="absolute bottom-0 left-0 w-[22px] h-[22px] rounded-[6px] bg-[#8CC53F]" />
              <span className="absolute top-[3px] left-[3px] w-[13px] h-[13px] rounded-[4px] bg-[#21A8CB]" />
            </span>
            <span className="font-display text-lg font-bold leading-none">
              <span className="text-[#4CC0DE]">INTER</span><span className="text-white font-normal">SCOPE</span>
              <span className="block text-[8px] tracking-[0.5em] text-[#8CC53F] mt-0.5 font-semibold">ADS</span>
            </span>
          </div>
          <p className="text-sm text-slate-400 leading-relaxed">Performance marketing built to scale. We turn media spend into measurable growth across global markets.</p>
          <div className="flex gap-3 mt-5">
            <a href={company.instagram} target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full bg-white/5 border border-white/10 grid place-items-center text-slate-300 hover:text-white hover:border-blue-400/50 hover:bg-white/10 transition-colors"><Instagram size={18} /></a>
            <a href={company.linkedin} target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full bg-white/5 border border-white/10 grid place-items-center text-slate-300 hover:text-white hover:border-blue-400/50 hover:bg-white/10 transition-colors"><Linkedin size={18} /></a>
            <a href={`https://wa.me/${company.whatsapp}`} target="_blank" rel="noreferrer" aria-label="WhatsApp" className="w-10 h-10 rounded-full bg-white/5 border border-white/10 grid place-items-center text-slate-300 hover:text-[#25D366] hover:border-[#25D366]/50 transition-colors"><MessageCircle size={18} /></a>
          </div>
        </div>

        <div>
          <h4 className="font-display text-sm font-semibold text-white mb-4">Company</h4>
          <ul className="space-y-2.5">
            {navLinks.map((l) => (
              <li key={l.to}><Link to={l.to} className="text-sm text-slate-400 hover:text-blue-400 transition-colors">{l.label}</Link></li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-display text-sm font-semibold text-white mb-4">Solutions</h4>
          <ul className="space-y-2.5">
            {services.slice(0, 6).map((s) => (
              <li key={s.slug}><Link to="/solutions" className="text-sm text-slate-400 hover:text-blue-400 transition-colors">{s.title}</Link></li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-display text-sm font-semibold text-white mb-4">Get in touch</h4>
          <ul className="space-y-3">
            <li><a href={`tel:${company.phone}`} className="flex items-center gap-3 text-sm text-slate-400 hover:text-white transition-colors"><Phone size={16} className="text-blue-400" /> {company.phone}</a></li>
            <li><a href={`mailto:${company.email}`} className="flex items-center gap-3 text-sm text-slate-400 hover:text-white transition-colors"><Mail size={16} className="text-blue-400" /> {company.email}</a></li>
            <li className="flex items-center gap-3 text-sm text-slate-400"><MapPin size={16} className="text-blue-400" /> {company.location}</li>
          </ul>
          <Link to="/contact" className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-blue-400 hover:gap-2.5 transition-all">Start a campaign <ArrowUpRight size={16} /></Link>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 md:px-8 py-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-xs text-slate-500">© {new Date().getFullYear()} {company.legalName}. All rights reserved.</p>
          <p className="text-xs text-slate-500">Acquire. Optimize. Scale.</p>
        </div>
      </div>
    </footer>
  );
}
